module.exports = __webpack_public_path__ + "static/img/agent-4.73a1dd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/agent-4.jpg
// module id = Oyhx
// module chunks = 1